import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { TTUUID } from '@/global/TTUUID';
import { ServiceCaller } from '@/services/ServiceCaller';

export class DocumentSubViewController extends JobApplicantSubBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
		} );

		super( options );
	}

	init( options ) {
		this.document_api = TTAPI.APIDocumentPortal;
		this.attachment_data = null;
	}

	render() {
		var $this = this;
		var list_tpl = Global.loadWidget( 'views/portal/hr/my_profile/MyProfileSubView.html' );
		var unique_id = this.sub_view_id + '-' + this.model.id;
		this.unique_id = unique_id;
		this.sub_view = _.template( list_tpl )( {} );
		if ( this.table_container.find( '.table-container' ).length == 0 ) {
			this.table_container.html( '<div class="table-responsive"><table class="table table-condensed table-bordered table-container"><thead></thead><tbody></tbody></table></div>' );
		}
		if ( this.table_container.find( '#' + unique_id ).length === 0 ) {
			var tbody = $( '<tr>' ).attr( 'id', unique_id );
			$( this.table_container.find( 'tbody' )[0] ).append( tbody );
		} else {
			this.table_container.find( '#' + unique_id ).html( '' );
		}
		var thead = $( '<tr>' );
		for ( var column in this.display_columns ) {
			if ( !this.display_columns.hasOwnProperty( column ) ) {
				continue;
			}
			var column_val;
			switch ( column ) {
				default:
					if ( !this.model.get( column ) ) {
						column_val = '';
					} else {
						column_val = this.model.get( column );
					}
					if ( column === 'name' ) {
						this.table_container.find( '#' + unique_id ).append( '<td><a class="download-attachment" href="javascript:void(0);">' + column_val + '</a></td>' );
					} else {
						this.table_container.find( '#' + unique_id ).append( '<td>' + column_val + '</td>' );
					}
					break;
			}
			thead.append( '<th>' + this.display_columns[column] + '</th>' );
		}
		thead.append( '<th>' + $.i18n._( 'Action' ) + '</th>' );
		if ( this.table_container.find( 'thead' ).html() === '' ) {
			this.table_container.find( 'thead' ).html( thead );
		}
		this.table_container.find( '#' + unique_id ).append( this.sub_view );
		this.table_container.find( '#' + unique_id ).find( '.download-attachment' ).unbind( 'click' ).bind( 'click', function( e ) {
			var filter = {};
			filter.filter_data = {};
			filter.filter_data.id = $this.model.id;
			$this.document_api['getAttachment']( filter, {
				onResult: function( result_data ) {
					$this.downloadFile( result_data );
				}
			} );
		} );
		this.table_container.find( '#' + unique_id ).find( '.edit-icon' ).unbind( 'click' ).bind( 'click', function( e ) {
			$this['get' + $this.sub_view_id]( function() {
				$this.setEditView();
			} );
		} );
		this.table_container.find( '#' + unique_id ).find( '.delete-icon' ).unbind( 'click' ).bind( 'click', function( e ) {
			$this['get' + $this.sub_view_id]( function() {
				$this.onDeleteClick();
			} );
		} );
	}

	downloadFile( result_data ) {
		var $this = this;
		var data = result_data.getResult();
		if ( data.length > 0 ) {
			var document_id = data[0].id;
			var document_revision_id = data[0].document_revision_id;

			var url = ServiceCaller.getAPIURL( 'Class=APIDocumentPortal&Method=downloadAttachment' + '&v=2' );
			if ( LocalCacheData.getAllURLArgs().company_id ) {
				url = url + '&company_id=' + LocalCacheData.getAllURLArgs().company_id;
			}

			var post_data = { parent_id: document_id, object_id: document_revision_id };

			Global.APIFileDownload( null, null, post_data, url );
		}
	}

	initOptions() {
		var $this = this;
	}

	getDocument( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.id = this.model.id;
		this.api['getDocument']( filter, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					$this.model.set( result_data );
					if ( callback ) {
						callback();
					}
				} else {
					$this.showErrorAlert( result );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	setCurrentEditRecordData() {
		super.setCurrentEditRecordData();
		var field_selector;
		var field_control;
		//Set current edit record data to all widgets
		for ( var key in this.model.attributes ) {
			if ( !this.model.has( key ) ) {
				continue;
			}
			switch ( key ) {
				case 'private':
				case 'template':
					field_selector = 'input[name="' + key + '"]';
					if ( this.model.get( key ) === true ) {
						this.$( field_selector ).prop( 'checked', 'checked' );
					} else if ( this.model.get( key ) === false ) {
						this.$( field_selector ).removeAttr( 'checked' );
					}
					break;
				default:
					if ( this.model.get( key ) === false ) {
						this.model.set( key, '' );
					}
					field_selector = '.form-control[name="' + key + '"]';
					field_control = this.$( field_selector );
					if ( field_control && field_control[0] ) {
						this.$( field_selector ).val( this.model.get( key ) );
					}
					break;

			}
		}
	}

	onSaveClick() {
		var $this = this;
		if ( _.size( this.edit_view_error_ui_dic ) > 0 ) {
			return;
		}
		if ( !this.model.get( 'name' ) ) {
			this.model.set( 'name', 'Resume' + ' - ' + LocalCacheData.getPortalLoginUser().first_name + ' ' + LocalCacheData.getPortalLoginUser().last_name );
		}
		this.api['set' + this.sub_view_id]( this.model.toJSON(), {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( result_data !== true && TTUUID.isUUID( result_data ) && result_data != TTUUID.zero_id && result_data != TTUUID.not_exist_id ) {
						$this.model.set( 'id', result_data );
					}
					$this.onSaveResult( result, function() {
						$this['get' + $this.sub_view_id]( function() {
							ProgressBar.changeProgressBarMessage( 'Processing...' );
							// $this.render();
							$this.closeEditView();
							$this._delegate.refreshProfile();
						} );
					} );
				} else {
					$this.setErrorTips( result );
				}
			}
		} );
	}

	onSaveResult( document_result, callback ) {
		var document_id = document_result.getResult();
		var $this = this;

		// var file = this.attachment_data;

		var file = this.$( 'input[name="file_data"]' )[0].files[0];
		var form = new FormData();
		if ( document_id === true ) { // edit
			document_id = this.model.id;
		}
		//Save a document revision data if has upload file, otherwise don't
		if ( file ) {
			var document_name = this.model.get( 'name' );
			var revision = this.model.get( 'revision' );
			var document_revision_id = this.document_api.addAttachment( document_name, document_id, revision, { async: false } ).getResult()['document_revision_id'];
			form.append( 'file_data', file );
			this.uploadFile( form, document_revision_id, callback );
		} else {
			callback();
		}
	}

	uploadFile( file_data, document_revision_id, callback ) {
		var url = ServiceCaller.getAPIURL( 'Class=' + this.document_api.className + '&Method=uploadAttachment' + '&v=2' );
		if ( LocalCacheData.getAllURLArgs().company_id ) {
			url = url + '&company_id=' + LocalCacheData.getAllURLArgs().company_id;
		}
		url = url + '&object_id=' + document_revision_id;
		var message_id = TTUUID.generateUUID();
		ProgressBar.showProgressBar( message_id );
		ProgressBar.changeProgressBarMessage( 'File Uploading' );
		$.ajax( {
			url: url, //Server script to process data
			headers: {
				//Handle CSRF tokens and related headers here.
				'X-Client-ID': 'Browser-TimeTrex',
				'X-CSRF-Token': getCookie( 'CSRF-Token' ),
			},
			type: 'POST',
			data: file_data,
			success: function( res ) {
				ProgressBar.removeProgressBar();
				if ( res.error.length > 0 ) {
					IndexViewController.instance.router.showTipModal( res.error );
					return;
				}
				callback();
			},
			cache: false,
			contentType: false,
			processData: false
		} );
	}

	onFormItemChange( e, doNotValidate ) {
		var key = e.currentTarget.name;
		this.model.set( key, $( e.currentTarget ).val() );
		switch ( key ) {
			// case 'country':
			// case 'identification_country':
			// 	var widget = this.$('select[name="' + key + '"]');
			// 	widget.val( null );
			// 	break;
			case 'private':
			case 'template':
				if ( $( e.currentTarget ).is( ':checked' ) ) {
					this.model.set( key, true );
				} else {
					this.model.set( key, false );
				}
				break;
		}
		if ( !doNotValidate ) {
			this.validate();
		}
	}
}